import React, { useEffect } from 'react'
import Header from '../../Components/Header'
import Footer from '../../Components/Footer'
import "../ContactUsComponent/ContactUs.css"

const ContactUs = () => {
    useEffect(()=>{
    window.scrollTo(0,0)
    },[])
  const offices = [
    {
      title: "Regional Head Office",
      address: "House No. 41, Tarini Nagar, Mission Gate, Shankara Road, Sundargarh"
    },
    {
      title: "Bhubaneswar Office",
      address: " PLOT NO 516/1754/1755/1757, MARUTI CORNOR, 3RD FLOOR, PATIA, BHUBANESWAR, Khordha, Orissa, India, 751024"
    },
    {
      title: "Sambalpur Office",
      address: "Maa Tarini Residency, Budharaja, Main Road, Behind IOCL petrol pump, QNO-F2F, 2nd floor, Sambalpur, Odisha"
    },
    {
      title: "Jharsuguda Office",
      address: "Postal address - AKA- HSB Associate, Behera mal, Shankar Bihar, Jharsuguda - 768203, Post- industrial Estate, Dist- Jharsuguda, Odisha"
    }
  ]

  return (
    <>
      <Header/>
      
      {/* Hero Section */}
      <section className='contact-details-hero'>
        <article className='contact-details-hero-gap'>
          <div className='contact-details-texts'>
            <h1 className='contact-details-head-text'>
              Let's Connect
            </h1>
            <p className='contact-details-sub-text'>
              Whether you're looking to collaborate, explore our services,
              <br /> or simply connect, we'd love to hear from you.
            </p>
          </div>
        </article>
      </section>

      {/* Our Offices Section */}
      <section className='our-offices-section'>
        <div className='our-offices-container'>
          <div className='our-offices-header'>
            <div className='offices-title-wrapper'>
              <h2 className='our-offices-title'>OUR OFFICES</h2>
              <div className='offices-title-accent'></div>
            </div>
          </div>

          <div className='offices-grid'>
            {offices.map((office, index) => (
              <div key={index} className='office-card' data-aos="fade-up" >
                <div className='office-card-inner'>
                  <div className='office-icon'>
                    <svg width="40" height="40" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L2 7V17L12 22L22 17V7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M12 22V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      <path d="M22 7L12 12L2 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h3 className='office-title'>{office.title}</h3>
                  <p className='office-address'>{office.address}</p>
                  <div className='office-card-overlay'></div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      
      <Footer/>
    </>
  )
}

export default ContactUs